( function ( $ ) {
	// estimate form

	if ( $( '#career__form' ).length > 0 ) {
		$( '#phone, #zip1, #zip2' ).on( 'keypress', function ( event ) {
			event = event || window.event;
			if ( event.charCode && event.charCode !== 0 && event.charCode !== 46 && ( event.charCode < 48 || event.charCode > 57 ) ) {
				return false;
			}
		} );

		/*
		const emailVal = document.getElementById( 'email-val' );
		const emailVal2 = document.getElementById( 'email-check' );

		emailVal2.oninput = function () {
			if ( emailVal.value === this.value ) {
				document.getElementById( 'mail-valid' ).textContent = '';
				document.getElementById( 'career-send' ).disabled = false;
				document.getElementById( 'career-send' ).classList.remove( 'disabled' );
			} else {
				document.getElementById( 'mail-valid' ).textContent = 'Emails are different!';
				document.getElementById( 'career-send' ).disabled = true;
				document.getElementById( 'career-send' ).classList.add( 'disabled' );
			}
		};
		*/

		$( '#phone' ).on( 'keypress', function ( event ) {
			event = event || window.event;
			if ( event.charCode && event.charCode !== 0 && event.charCode !== 46 && ( event.charCode < 48 || event.charCode > 57 ) ) {
				return false;
			}
		} );

		const requiredQuestion3 = () => {
			const sendB = document.getElementById( 'career-send' );
			const targetState = document.getElementById( 'input-state' );
			const reqSelectState = document.getElementById( 'select-state' );
			const targetDay = document.getElementById( 'input-bthday' );
			const reqSelectDay = document.getElementById( 'select-bthday' );
			const targetMonth = document.getElementById( 'input-bthmonth' );
			const reqSelectMonth = document.getElementById( 'select-bthmonth' );
			const targetYear = document.getElementById( 'input-bthyear' );
			const reqSelectYear = document.getElementById( 'select-bthyear' );
			const reqSelectBth = document.getElementById( 'select-bth' );

			sendB.onclick = function () {
				if ( ! targetDay.value ) {
					reqSelectDay.style.border = '1px solid red';
				}
				if ( ! targetMonth.value ) {
					reqSelectMonth.style.border = '1px solid red';
				}
				if ( ! targetYear.value ) {
					reqSelectYear.style.border = '1px solid red';
				}
				if ( ! targetState.value ) {
					reqSelectState.style.border = '1px solid red';
					document.getElementById( 'select_alert2' ).textContent = 'Select state!';
				}
			};
			//	if ((targetDay.value != '') && (targetMonth.value != '') && (targetYear.value != ''))  {
			//		    console.log('заполнены');
			//		    document.getElementById('select_alert1').textContent = ''
			//	    }

			let observer1 = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					if ( targetState.value !== '' ) {
						reqSelectState.style.border = '1px solid #A3ACC2';
						document.getElementById( 'select_alert2' ).textContent = '';
					}
				} );
			} );
			let observer2 = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					if ( targetDay.value !== '' ) {
						reqSelectDay.style.border = '1px solid #A3ACC2';
						document.getElementById( 'select_alertDay' ).textContent = '';
					}
				} );
			} );
			let observer3 = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					if ( targetMonth.value !== '' ) {
						reqSelectMonth.style.border = '1px solid #A3ACC2';
						document.getElementById( 'select_alertMonth' ).textContent = '';
					}
				} );
			} );
			let observer4 = new MutationObserver( function ( mutations ) {
				mutations.forEach( function ( mutation ) {
					if ( targetYear.value !== '' ) {
						reqSelectYear.style.border = '1px solid #A3ACC2';
						document.getElementById( 'select_alertYear' ).textContent = '';
					}
				} );
			} );

			const config = {
				attributes: true,
				childList: true,
				characterData: true,
			};
			observer1.observe( targetState, config );
			const config2 = {
				attributes: true,
				childList: true,
				characterData: true,
			};
			observer2.observe( targetDay, config );
			const config3 = {
				attributes: true,
				childList: true,
				characterData: true,
			};
			observer3.observe( targetMonth, config );
			const config4 = {
				attributes: true,
				childList: true,
				characterData: true,
			};
			observer4.observe( targetYear, config );
		};
		requiredQuestion3();

		const clearForm = () => {
			const resetButton = document.getElementById( 'btn-reset' );
			resetButton.onclick = function () {
				document.getElementById( 'career-send' ).reset();
			};
		};
		clearForm();

		const formph = $( '#career__form' );
		formph.validate( {
			// eslint-disable-next-line object-shorthand
			submitHandler: function ( formph ) {
				$( '#career-send' ).attr( 'disabled', true );
				const fd = new FormData( formph );
				$.ajax( {
					async: true,
					url: '/wp-admin/admin-ajax.php',
					type: 'POST',
					data: fd,
					cache: false,
					contentType: false,
					processData: false,
					success() {
						window.location.href = '/ty-application';
						//$( '.flash-success' ).css( 'display', 'block' ).delay( 5000 ).fadeOut( 1000 );
						//formph.reset();
						//$( '#career-send' ).attr( 'disabled', false );
					},
					error() {
						$( '.flash-warning' ).css( 'display', 'block' ).delay( 5000 ).fadeOut( 1000 );
					},
				} );
				return false;
			},
			rules: {
				career_first_name: {
					required: true,
				},
				career_last_name: {
					required: true,
				},
				career_address_line_one: {
					required: true,
				},
				career_city: {
					required: true,
				},
				career_zip_code: {
					required: true,
				},
				career_prime_phone: {
					required: true,
				},
				career_email: {
					required: true,
				},
			},
			messages: {
				career_first_name: {
					required: 'Enter first name!',
				},
				career_last_name: {
					required: 'Enter last name!',
				},
				career_address_line_one: {
					required: 'Enter street address!',
				},
				career_city: {
					required: 'Enter city!',
				},
				career_zip_code: {
					required: 'Enter zip code!',
				},
				career_prime_phone: {
					required: 'Enter primary phone!',
				},
				career_email: {
					required: 'Email must be in the format name@domain.com!',
				},
			},
			errorElement: 'div',
			focusInvalid: true,
			errorClass: 'input_error',
		} );
		const form = document.querySelector( 'form' );
		const submit = form.querySelector( 'button' );
		//const inputs = document.querySelectorAll( 'input, select, textarea' );
		//   inputs.forEach((input) => {
		//   input.addEventListener('invalid', (event) => {
		//     input.classList.add('error');
		//   });
		//   input.addEventListener('blur', () => {
		//     input.checkValidity();
		//     changeStateSubmit();
		//   });
		//   input.addEventListener('input', () => {
		//     changeStateSubmit();
		//  });
		//  });

		function changeStateSubmit() {
			if ( form.checkValidity() ) {
				submit.disabled = false;
				submit.classList.remove( 'disabled' );
			} else {
				submit.classList.add( 'disabled' );
				submit.disabled = true;
			}
		}
		changeStateSubmit();
	}
} )( jQuery );
